import React, { useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';

import CheckBoxToggle from 'components/Common/CheckBoxToggle';
import ModalPortal from 'components/ModalPortal';
import MessageModal from 'components/MessageModal';
import permissions, { checkPermissions } from 'config/permissions';
import { personUnlinkContact } from 'actions/customer';
import { connect } from 'react-redux';
import { setApi } from '../../../reducers/grid';
import { withRouter } from 'react-router-dom';

const mapStateToProps = state => ({
	activeGridKey: state.grid.gridKey
});

function UnlinkPersonCell (props) {
	const { data, t, updateApiGrid, match, activeGridKey } = props;
	const [checked, setChecked] = useState(_.get(data, 'actual'));
	const [modal, setModal] = useState(false);
	const canUnlink = !checkPermissions(permissions.CustomerOperations.action_unlinkContactPersons);

	const [isLoading, setIsLoading] = useState(false);
	
	useEffect(() => {
		setChecked(_.get(data, 'actual'));
	}, [_.get(data, 'actual')]);
	
	function closeModal () {
		setModal(false);
	}
	
	function click (e) {
		e.preventDefault();
		e.stopPropagation();

		if (!!checked && !canUnlink) {
			setModal(true);
		}
	}
	
	async function submit () {
		const { id, currentLink } = data;
		
		// currentLink data is available from customer page
		// data.entityId => person page
		let params = {
			personId: currentLink ? id : data.entityId,
			customerId: currentLink ? currentLink.entityId : data.entityId,
			linkId: currentLink ? currentLink.id : data.id
		};


		setIsLoading(true);
		
		await personUnlinkContact(params);
		updateApiGrid({}, activeGridKey );
		setChecked(false);
		setIsLoading(false);
		setModal(false);
	}
	
	return (
		<div onClick={click} className='crm-wrapper data-cell' title={checked ? 'Активний' : 'Неактивний'}>
			<CheckBoxToggle
				checked={checked}
				disabled={canUnlink}
			/>
			<CSSTransition
				in={modal}
				classNames='fade'
				appear
				enter
				exit
				timeout={300}
				mountOnEnter
				unmountOnExit
			>
				<ModalPortal onClose={closeModal} className='modal-small modal-center'>
					<MessageModal
						titleModal={t('persons.attention')}
						contentModalText={t('persons.linkModalMessage')}
						primaryButton
						primaryButtonText={t('persons.allow')}
						onClickPrimaryButton={submit}
						secondaryButton
						secondaryButtonText={t('persons.disallow')}
						onClickSecondaryButton={closeModal}
						isLoading={isLoading}
					/>
				</ModalPortal>
			</CSSTransition>
		</div>
	)
}

export default connect(mapStateToProps, { updateApiGrid: setApi })(withRouter(UnlinkPersonCell));
